import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";

declare var instituicaoConstants: { INSTITUICAO: any };
@Component({
  selector: "app-recuperar-senha",
  templateUrl: "./recuperar-senha.page.html",
  styleUrls: ["./recuperar-senha.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule
  ],
})
export class RecuperarSenhaPage implements OnInit {
  email = "";
  formEnviado = false;
  error = false;
  errorMessage = "";
  validations_form: FormGroup;

  constructor(
    public translate: TranslateService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public loadingController: LoadingController // private translate: TranslateService,
  ) {
    this.validations_form = this.formBuilder.group({
      email: new FormControl("", [Validators.required, Validators.email]),
    });
  }

  ngOnInit() {}

  validation_messages = {
    email: [
      { type: "required", message: this.translate.instant("Informe um e-mail válido")},
      { type: "email", message: "" },
    ],
  };

  onSubmit(form: { email: any }) {
    var loader = this.loadingController.create({
      message: "Enviando",
    });

    loader.then();
    this.http
      .post<any>(environment.API_URL + "/recuperar-senha", {
        ambiente: "app",
        email: form.email,
        idInstituicao: instituicaoConstants.INSTITUICAO,
      })
      .subscribe((res) => {
        if (res.error) {
          this.error = true;
          this.errorMessage = res.message;
        }
        this.formEnviado = true;
        loader.finally();
      });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
